module.exports = __webpack_public_path__ + "img/CraneTruck.a5fa1bd3.png";